import { Button } from "@/components/ui/button";
import TrustSection from "./TrustSection";
import { trackAffiliateClick } from "@/utils/analytics";
import { getAffiliateUrl } from "@/constants/affiliate";

const BenefitsCTA = () => {
  const handleAffiliateClick = () => {
    trackAffiliateClick('cta-benefits-section', 'benefits-section');
  };
  return (
    <section className="py-12 bg-primary/5">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h3 className="text-2xl md:text-3xl mb-4 text-foreground">
          Ready to Transform Your <span className="text-primary font-bold">Hydration Experience?</span>
        </h3>
        <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
          Join thousands who have made crystal-infused hydration a beautiful part of their wellness routine.
        </p>
        <div className="inline-block">
          <a href={getAffiliateUrl("benefits-section")} rel="sponsored nofollow noopener" target="_blank" className="inline-block" onClick={handleAffiliateClick}>
            <Button id="cta-benefits-section" className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-lg font-semibold shadow-lg">
              Check Price & Availability
            </Button>
          </a>
          <TrustSection />
        </div>
      </div>
    </section>
  );
};

export default BenefitsCTA;
